import type { ComponentProps } from 'react'

import { useTheme } from '@emotion/react'

import { TextButton } from '../text-button'

import * as styles from './continue-button.styles'

type ButtonProps = ComponentProps<typeof TextButton>
type Props = ButtonProps & {
  floating?: boolean
  containerRef?: (node: HTMLDivElement | null) => void
  noMargin?: boolean
}

export const ContinueButton = ({
  children,
  floating,
  containerRef,
  noMargin = false,
  ...other
}: Props) => {
  const theme = useTheme()

  const button = (
    <TextButton
      color="primary"
      css={[
        styles.continueButton(theme),
        (other.fullWidth ?? false) && styles.fullWidth(theme),
        noMargin && styles.noMargin,
      ]}
      data-testid="continue-button"
      type="submit"
      {...other}
    >
      {children}
    </TextButton>
  )

  if (!floating) {
    return button
  }

  return (
    <div ref={containerRef} css={styles.floatingContainer(theme)}>
      {button}
    </div>
  )
}
